import axios from "axios"
// import fs from "@/services/FormatService"
// import _ from "lodash"

export default {
	getDistrictProgram(districtID) {
		return axios.get(`/v1/district/program/${districtID}`)
	},
	getSectionProgram(sectionID) {
		return axios.get(`/v1/section/program/${sectionID}`)
	},
	getDistrictPrograms(districtID) {
		return axios.get(`/v1/district/programs/${districtID}`)
	},
	getContextProgram() {
		return axios.get(`/v1/context/program`)
		// let items = []
		// _.each(fs.profileQuestions, pq => {
		// 	items.push({
		// 		id: pq.id,
		// 		text: pq.text
		// 	})
		// })
		// let program = {
		// 	profile: {
		// 		items: items
		// 	},

		// 	pitch_config: {
		// 		rubric: {
		// 			id: "rubric-101",
		// 			name: "Standard Pitch Feedback Rubric",
		// 			categories: [
		// 				{
		// 					id: "101",
		// 					name: "Problem",
		// 					prompt: "Identifies and explains the scope of the problem , provides evidence the problem exists, and identifies potential customers who will benefit from the problem being solved."
		// 				},
		// 				{
		// 					id: "102",
		// 					name: "Value Proposition",
		// 					prompt: "Identifies the solution and the value the solution provides potential customers. Details of a prototype presented. Evidence presented the prototype meets customer needs and adds value compared to alternate solutions. Next steps in prototype development discussed."
		// 				},
		// 				{
		// 					id: "103",
		// 					name: "Delivery",
		// 					prompt: "Engaging opening sparks the interest of the audience. Team members create a professional presence through attire, verbal communication, slide deck, prototype display, and communication with the audience."
		// 				},
		// 				{
		// 					id: "104",
		// 					name: "Validation",
		// 					prompt: "Customer discovery data is collected, analyzed and presented to support the value proposition. Data guides next steps in developing the prototype and identifying customer segments, channels, and relationships."
		// 				},
		// 				{
		// 					id: "105",
		// 					name: "Resources",
		// 					prompt: "Identifies the team's capabilities and interest in solving the problem. Identifies key partners, key activities, and other resources needed for the solution to be sustainable or generate revenue."
		// 				},
		// 			]
		// 		}
		// 	}
		// }
		// return fs.mockAPIResponse(program)
	}
}
